export const ROUTES = {
  INSTITUTIONAL: { PATH: "/", NAME: "Institucional" },
  LOGIN: { PATH: "/login", NAME: "Login" },
  FORGOT_PASSWORD: { PATH: "/esqueceu-senha", NAME: "Esqueceu a Senha" },
  DASHBOARD: { PATH: "/dashboard", NAME: "Dashboard" },
  COLLABORATORS: { PATH: "/colaboradores", NAME: "Colaboradores" },
  FLEET: { PATH: "/frota", NAME: "Frota" },
  SHIPPING_COMPANIES: { PATH: "/empresas", NAME: "Empresas" },
  PAYROLLS: { PATH: "/folha-pagamento", NAME: "Folhas de pagamento" },
  COMPENSATORY_TIMES: { PATH: "/banco-horas", NAME: "Banco de horas" },
  REPORTS: { PATH: "/relatorios", NAME: "Relatórios" },
  MACROS: { PATH: "/macros", NAME: "Macros e Pontos" },
  JOURNEY_RULES: { PATH: "/regras-jornada", NAME: "Regras de Jornada" },
  SESSIONS: { PATH: "/secoes", NAME: "Seções" },
  CONVENTIONS: { PATH: "/convencoes", NAME: "Convenções" },
  SYNDICATES: { PATH: "/sindicatos", NAME: "Sindicatos" },
  PROFILE: { PATH: "/perfil", NAME: "Perfil" },
  INFRACTIONS: { PATH: "/infracoes", NAME: "Infrações" },
  JOURNEY_CONTROL: { PATH: "/controle-jornada", NAME: "Controle de Jornada" },
  PRIVACY_POLICY: { PATH: "/politica-privacidade", NAME: "Política de Privacidade" },
};

export type RoutesType = typeof ROUTES;